import { version as e } from "../../version.js";
import { getConsoleStyle as t } from "./styledLogs.js";
//#region src/utils/init/checkForReleaseVersion.ts
var n = "https://uikit.developers.rio.cloud/versionsList.json", r = async () => {
	let r = (e) => console.log("%c%s", t(), e);
	try {
		let { latest_release: t } = await (await fetch(n)).json();
		t > "3.0.1" && r(`🆕 You are using version ${e} of the UIKIT while the latest released version is ${t}. Please consider updating asap.`);
	} catch {
		r("Failed to fetch UIKIT version list.");
	}
};
//#endregion
export { r as checkForReleaseVersion };

//# sourceMappingURL=checkForReleaseVersion.js.map